import { createFileRoute } from "@tanstack/react-router"

import { UsersPanel } from "@/pages/UsersPanel"

export const Route = createFileRoute("/administration/users")({
  component: UsersPanel,
})
